import * as React from 'react';
import type { UpdateServiceOrderProductPayload } from 'contracts/service-order-products';
import { api } from 'services/api';

type Params = {
  serviceOrderProductId: number;
  payload: UpdateServiceOrderProductPayload;
}

export const useUpdateServiceOrderProduct = () => {
  const updateServiceOrderProduct = React.useCallback(async (params: Params) => {
    const url = `/inventory/service-order-products/${params.serviceOrderProductId}`;
    await api.put(url, params.payload);
  }, []);

  return {
    updateServiceOrderProduct
  }
}